import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M21.5921 11.3169L12.7441 3.53495C12.3321 3.17195 11.6641 3.17195 11.2571 3.53495L2.41208 11.3169C2.00008 11.6799 2.11008 11.9739 2.65908 11.9739H5.38808V19.9419C5.38808 20.3759 5.74508 20.7359 6.18308 20.7359H9.52308V15.4939C9.52308 15.0599 9.88008 14.6989 10.3181 14.6989H13.6901C14.1301 14.6989 14.4851 15.0509 14.4851 15.4939V20.7359H17.8251C18.2651 20.7359 18.6201 20.3789 18.6201 19.9419V11.9709H21.3491C21.8901 11.9709 22.0001 11.6799 21.5931 11.3169H21.5921Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'HomeFill');

export default Icon;
